const getters = {
    getJobList(state) {
        return state.jobs;
    },
    getJob(state) {
        return state.job;
    }
}

export default getters;
